import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApiProvider } from '@trinetra/shared';
import App from './App';
import { createCloudApi } from './api';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ApiProvider api={createCloudApi()}>
      <App />
    </ApiProvider>
  </React.StrictMode>
);
